<template>
  <form class="t-addUser" @submit.stop.prevent="">
    <h2> {{ addNewUsersDialog.title }} </h2>
    <cmp-userListEdit :load="load"></cmp-userListEdit>
    <button type="button" class="t-btn" :class="{_disabled: disabledBtn}" @click.stop.prevent="Submit()"><span>{{addNewUsersDialog.btn}}</span></button>
  </form>
</template>

<script>
    import {store} from '../../store'

    import UsersListEdit from '../UsersListEdit.vue'
    import {mapGetters, mapActions} from 'vuex';

    export default {
        data(){
            return{
                disabledBtn: false,
                action: 'dialog/update',
                personalInfo: false,
                load: false,
            }
        },
        props: ['props'],
        components: {
            'cmp-userListEdit': UsersListEdit
        },
        computed: {
            ...mapGetters(['mobile']),
            ...mapGetters('staticText', ['addNewUsersDialog']),
            ...mapGetters('dialog', ['contactsListToAdd', 'contactsListToRemove']),
            id(){
                return this.$route.query.sel;
            },
        },
        beforeCreate() {
            store.dispatch('dialog/LoadContactsList', this.$router.currentRoute.query.sel ).then(()=>{
                this.load = true;
            })
        },
        methods: {
            ...mapActions('modal', ['modalDialogClose']),
            ...mapActions('msg', ['showMsg']),
            Submit(){
                let fd = new FormData();
                fd.append('id', this.id);
                fd.append('usersAdd', this.contactsListToAdd);
                fd.append('usersRemove', this.contactsListToRemove);

                this.$http.put(this.action, fd)
                    .then(response => response.json())
                    .then(data => {

                    store.dispatch('dialog/LoadDialogList').then(() => {
                        store.dispatch('dialog/LoadMessageList', this.$router.currentRoute.query.sel ).then(()=>{
                            this.modalDialogClose();
                        })
                    });

                    }, data => {
                        this.modalDialogClose();
                        this.showMsg('Упс, что-то пошло не так, попробуйте позже')
                    });
            },
        }
    }
</script>

<style lang="sass">
.t-addUser
    width: 420px
    margin: 0 auto
    background: #ffffff
    padding: 24px
    border-radius: 16px
    &__hint
        font-size: 14px
        color: $grey
        margin-top: 8px
    .t-input:after
        bottom: 25px
.t-userList
    max-height: 300px
    overflow: scroll
    position: relative
    &:after
        content: ''
        display: block
        background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);
        width: 100%
        height: 74px
        position: sticky
        bottom: 0
        left: 0

@media (max-width: 769px)
  .t-createDialog
    width: 100%
</style>


// WEBPACK FOOTER //
// src/vue_components/ModalDialog/DialogAddNewUser.vue